import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';
import { questionnaire } from './questionnaire/questionnaire.interface';
import { report } from './report/report.interface';
import { tracker } from './tracker/tracker.interface';

const baseTranslateUrl = './assets/i18n';

export const modules: Array<IModuleTranslation> = [
  // resolve to: ./assets/i18n/{en|id}.json
  { baseTranslateUrl },
  // resolve to: ./assets/i18n/activity/{en|id}.json
  { baseTranslateUrl, moduleName: 'activity' },
  { baseTranslateUrl, moduleName: 'appointment' },
  { baseTranslateUrl, moduleName: 'assessment' },
  { baseTranslateUrl, moduleName: 'chat' },
  { baseTranslateUrl, moduleName: 'consent-form' },
  { baseTranslateUrl, moduleName: 'disclaimer' },
  { baseTranslateUrl, moduleName: 'ehr' },
  { baseTranslateUrl, moduleName: 'greetings' },
  { baseTranslateUrl, moduleName: 'home' },
  { baseTranslateUrl, moduleName: 'home-v3' },
  { baseTranslateUrl, moduleName: 'intro' },
  { baseTranslateUrl, moduleName: 'kit' },
  { baseTranslateUrl, moduleName: 'mcu' },
  { baseTranslateUrl, moduleName: 'order' },
  { baseTranslateUrl, moduleName: 'profile' },
  { baseTranslateUrl, moduleName: 'privacy-policy' },
  { baseTranslateUrl, moduleName: 'prodigy' },
  { baseTranslateUrl, moduleName: 'shop' },
  { baseTranslateUrl, moduleName: 'symptom' },
  { baseTranslateUrl, moduleName: 'tabs' },
  { baseTranslateUrl, moduleName: 'terms-of-service' },
  { baseTranslateUrl, moduleName: 'tour' },
  // resolve to: ./assets/i18n/auth/login/{en|id}.json
  {
    baseTranslateUrl,
    moduleName: 'login',
    pathTemplate: '{baseTranslateUrl}/auth/{moduleName}/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'register',
    pathTemplate: '{baseTranslateUrl}/auth/{moduleName}/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: 'nourish',
    pathTemplate: '{baseTranslateUrl}/questionnaire/{moduleName}/{language}'
  },
  ...report,
  ...tracker,
  ...questionnaire
];
